import React from 'react';
import { ErrorBoundary } from '@benzinga/core-ui';

interface MenuListProps<T> {
  currentItem: T;
  items: { label: string; value: T }[];
  onClick: (value: T) => void;
  whiteBg?: boolean;
  compact?: boolean;
}

export const MenuList = <T,>({ currentItem, items, onClick, whiteBg = false, compact = false }: MenuListProps<T>) => {
  if (compact) {
    return (
      <ErrorBoundary name="MenuList">
        <div className="flex w-full sm:inline-flex sm:w-auto max-w-full items-stretch sm:items-center rounded-lg border border-[#CEDDF2] bg-white p-0.5 gap-0.5">
          {items?.map(item => {
            const isSelected = item?.value === currentItem;
            return (
              <button
                key={String(item?.value)}
                type="button"
                className={`flex-1 sm:flex-none whitespace-nowrap text-sm capitalize font-semibold rounded-md px-2.5 py-2 sm:py-1 min-h-[40px] sm:min-h-0 transition-[color,background-color,box-shadow] duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-bzblue-700 ${
                  isSelected
                    ? 'bg-[#3F83F8] text-white shadow-sm'
                    : 'text-[#3F83F8] hover:bg-bzblue-100 hover:text-bzblue-800'
                }`}
                onClick={() => onClick?.(item?.value)}
              >
                {item?.label}
              </button>
            );
          })}
        </div>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary name="MenuList">
      <div className={'flex flex-row w-full rounded-md' + (whiteBg ? ' bg-white' : '')}>
        {items?.map((item, index) => {
          const isSelected = item?.value === currentItem;
          return (
            <React.Fragment key={String(item?.value)}>
              {index > 0 ? (
                <div className="w-px flex-shrink-0 self-stretch bg-[#3f83f8]/30 mx-1.5" aria-hidden />
              ) : null}
              <div
                className={`flex-1 min-w-[8.5rem] whitespace-nowrap text-sm text-center text-[#3F83F8] cursor-pointer px-4 py-1 capitalize font-bold rounded-md transition-[color,background-color] duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-bzblue-700 ${
                  isSelected ? 'bg-[#3F83F8] text-white' : 'hover:bg-bzblue-100 hover:text-bzblue-800'
                }`}
                onClick={() => onClick?.(item?.value)}
              >
                {item?.label}
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </ErrorBoundary>
  );
};
